import { useEffect, useRef, useState } from "react";
import "./IndividualNamePreview.css";
import { nameFields, composeIndividualName, individualNamePatch, capitalizeNameInitials } from "../../utils/individualName";

// Controlled name input shared by staff, client forms and ownership assistants.
export default function IndividualNamePreview({ inputClass, id, displayName = "", value = {}, onChange, disabled = false, framed = false, inputProps = {} }) {
  const [editing, setEditing] = useState(false);
  const { givenNames, familyName } = nameFields(value);
  const firstNameRef = useRef(null);
  const displayRef = useRef(null);
  const fullName = composeIndividualName(value, true);
  const change = (key, text) => onChange?.(individualNamePatch({ ...nameFields(value), [key]: capitalizeNameInitials(text) }));

  useEffect(() => {
    if (editing) firstNameRef.current?.focus();
  }, [editing]);

  return (
    <div
      className={framed ? `${inputClass} individualNamePreviewFrame` : undefined}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setEditing(false);
      }}
      onKeyDown={(event) => {
        if (editing && !event.nativeEvent.isComposing && ["Enter", "Escape"].includes(event.key)) {
          event.preventDefault();
          event.stopPropagation();
          setEditing(false);
          window.requestAnimationFrame(() => displayRef.current?.focus());
        }
      }}
    >
      {editing ? (
        <div className="individualNamePreviewFields">
          <input
            {...inputProps}
            ref={firstNameRef}
            className={inputClass}
            placeholder="First name"
            aria-label="First name"
            disabled={disabled}
            value={givenNames}
            onChange={(event) => change("givenNames", event.target.value)}
          />
          <input
            {...inputProps}
            className={inputClass}
            placeholder="Surname"
            aria-label="Surname"
            disabled={disabled}
            value={familyName}
            onChange={(event) => change("familyName", event.target.value)}
          />
        </div>
      ) : (
        <button
          ref={displayRef}
          id={id}
          type="button"
          className={`${inputClass} individualNamePreviewDisplay`}
          aria-label="Edit full name"
          disabled={disabled}
          onClick={() => setEditing(true)}
        >
          {fullName || displayName || "\u00A0"}
        </button>
      )}
    </div>
  );
}
